@use "../../styles/breakpoints";
@use "../../styles/text";
@use "table-sort-filter";

hp6-table {
  position: relative;
  display: block;
  table-layout: fixed;

  // table styles for sorting and filtering
  @include table-sort-filter.table-sort-filter;

  .hide-caption {
    caption {
      display: none;
    }
  }

  b {
    font-weight: var(--semantic-bold-font-weight);
  }

  thead {
    @include text.text-heading-xs;
    text-align: left;

    th,
    td {
      background-color: var(--color-primary-base);
      padding: var(--spacing-xs);
    }

    th {
      vertical-align: bottom;
    }
  }

  tbody {
    th,
    td {
      @include text.text-body-sm;
      padding: var(--spacing-xs);
      border: solid 1px var(--color-neutral-base);
      background-color: var(--color-neutral-xxlight);
      color: var(--color-text-base);
      text-align: left;
      vertical-align: top;
    }
  }

  @include breakpoints.xsmall {
    table {
      display: flex;
      flex-direction: column;
    }

    thead,
    tbody,
    tfoot,
    tr,
    th,
    td {
      display: block;
    }

    th:before {
      @include text.text-heading-xs;
      content: attr(data-row-column-header);
      padding-right: var(--spacing-xs);
      color: var(--color-text-xlight);
    }

    td:before {
      @include text.text-heading-xs;
      content: attr(data-row-header) ":";
      padding-right: var(--spacing-xs);
      color: var(--color-text-base);
      flex: 0 0 auto;
    }

    thead th,
    thead td {
      display: none;
    }

    tbody th,
    tbody td {
      display: flex;
      border: none;
    }

    tbody th {
      text-align: left;
      background-color: var(--color-primary-base);
      color: var(--color-text-xlight);
      display: flex;
      align-items: baseline;
    }

    tbody {
      td {
        padding-top: var(--spacing-xs);
        padding-bottom: 0;
        &:last-child {
          padding-bottom: var(--spacing-xs);
        }
      }
    }
  }

  @include breakpoints.small-up {
    thead {
      th,
      td {
        padding: var(--spacing-xs);
        background-color: var(--color-primary-base);
      }
    }

    tbody {
      th,
      td {
        padding: var(--spacing-sm) var(--spacing-xs);
        border: solid 1px var(--color-neutral-base);
      }
      th,
      th a {
        @include text.text-heading-xs;
      }
      td,
      td a {
        @include text.text-body-sm;
      }
      td:before {
        content: none;
      }
    }
  }

  @include breakpoints.small {
    thead th,
    thead td,
    tbody th,
    tbody td {
      padding: var(--spacing-xs) var(--spacing-xxs);
    }
  }
}
